// extracted by mini-css-extract-plugin
module.exports = {"container":"VehicleListTabs_container__s3QwV","tabs":"VehicleListTabs_tabs__MNHzY","tab":"VehicleListTabs_tab___s7tn"};